import Logo from "@/assets/PT Logo.svg";
export const LoadingIcon = () => {
  return (
    <img
      src={Logo}
      height={50}
      width={50}
      className="animate-bounce invert dark:invert-0"
      data-testid="form-loadingicon"
    />
  );
};

/*
POTENTIAL IMPROVEMENTS:
1. Accessibility: Add aria-label for screen readers to identify this as a loading indicator
2. Customization: Allow for different sizes via props
3. Alternate loading indicators: Provide options for different types of loading animations
4. Fallback: Include a text-based fallback when image fails to load
5. Performance: Consider using CSS-only loading animations instead of an image when appropriate
6. Color customization: Allow for custom colors instead of relying on invert
7. Context: Add loading text or context-specific messaging
*/
